"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcEmployeeList = class UcEmployeeList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    container;
    async $$load_container() {
        return this.parent.employees;
    }
    items;
    async $$load_items() {
        return this.container.data;
    }
    ux;
    dataMembers = ['container', 'items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                container: null,
                items: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_9282_getActionArgs($event) {
        return {
            name: "WEmployeeModal",
            props: {
                parent: this.parent,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_294572930540096_showModal_9284_getActionArgs($event) {
        return {
            name: "WEmployeeModal",
            props: {
                parent: this.parent,
                item: $event.scope.item,
            },
        };
    }
    async evh_294572930540096_clickPreventStop(event, scope) {
        return await this.actions.evh_294572930540096_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3365375699802249_rest_9286_getActionArgs($event) {
        return {
            method: "delete",
            container: this.container,
            resource: $event.scope.item,
        };
    }
    async act_3365375699802249_rest_9286_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_3365375699802249_clickPreventStop(event, scope) {
        return await this.actions.evh_3365375699802249_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9280 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9279 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9280,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9279],
        });
        const act_8320016629450276_showModal_9282 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_9282_getActionArgs,
            displayName: "create",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_9281 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_9282,
            event: "click.prevent.stop",
            displayName: "create",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_9281],
        });
        const act_294572930540096_showModal_9284 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_294572930540096_showModal_9284_getActionArgs,
            events: [],
        });
        const evh_294572930540096_clickPreventStop_9283 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_showModal_9284,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_294572930540096_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_294572930540096_clickPreventStop_9283],
        });
        const act_3365375699802249_rest_9286 = new core_1.actions.RestAction({
            actionArgs: this.act_3365375699802249_rest_9286_getActionArgs,
            confirm: this.act_3365375699802249_rest_9286_getConfirm,
            events: [],
        });
        const evh_3365375699802249_clickPreventStop_9285 = new core_1.actions.EventHandlerImpl({
            action: act_3365375699802249_rest_9286,
            event: "click.prevent.stop",
            displayName: "rest",
        });
        const evh_3365375699802249_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3365375699802249_clickPreventStop_9285],
        });
        return {
            act_7315092382398562_reloadComponentData_9280,
            evh_7315092382398562_reload_9279,
            evh_7315092382398562_reload,
            act_8320016629450276_showModal_9282,
            evh_8320016629450276_clickPreventStop_9281,
            evh_8320016629450276_clickPreventStop,
            act_294572930540096_showModal_9284,
            evh_294572930540096_clickPreventStop_9283,
            evh_294572930540096_clickPreventStop,
            act_3365375699802249_rest_9286,
            evh_3365375699802249_clickPreventStop_9285,
            evh_3365375699802249_clickPreventStop,
            create: act_8320016629450276_showModal_9282,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcEmployeeList.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcEmployeeList.prototype, "onParent", null);
UcEmployeeList = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcEmployeeList);
exports.default = UcEmployeeList;
vue_property_decorator_1.Vue.component("UcEmployeeList", UcEmployeeList);
